import { EventEmitter, Injectable } from '@angular/core';
import { KeyValEntry } from '@shared/KeyValStore';
import { HelperManagerAdminService } from '../helper-manager-admin.service';
import { KeyValAdminService } from '../key-val-admin.service';

@Injectable({
  providedIn: 'root'
})
export class VideoAvatarManagerService {
  private key = 'videoAvatarBackground';
  public onBackgroundUpdate: EventEmitter<KeyValEntry> = new EventEmitter<KeyValEntry>();
  public onBackgroundDelete: EventEmitter<KeyValEntry> = new EventEmitter<KeyValEntry>();

  constructor(
    private keyvalManager: KeyValAdminService,
    private helperManager: HelperManagerAdminService
  ) { }

  public setText(text: string): void {
    window.avatarbot_overrideText = text;
  }

  /**
   * @param source The source can be a skill id or a url
   */
  public async setBackgroundImage(source: string) {
    if (!source.startsWith('https')) {
      source = this.helperManager.getImageURlFromSkill(source);
    }
    const keyValEntry = await this.keyvalManager.set(this.key, source);
    this.onBackgroundUpdate.emit(keyValEntry);
  }

  public async unsetImage() {
    const keyValEntry = await this.keyvalManager.deleteKeyValEntry(this.key);
    this.onBackgroundDelete.emit(keyValEntry);
  }

  public async getBackgroundImage(): Promise<string> {
    return await this.keyvalManager.get(this.key) as string;
  }

  // No-op in der Admin-Vorschau: hier läuft keine echte LiveAvatar-Session (siehe bot-Variante).
  public async stop(): Promise<void> {
    return await Promise.resolve();
  }
}